<h5 class="mat-dialog-title">Delete
    <button class="mat-icon-button mat-dialog-close" (click)="onCloseClick()" >
       <span class="close">&times;</span> 
    </button>
</h5>
<div class="mat-dialog-content">
    Are you sure you want to delete this Master Policy?
</div>
<div class="mat-dialog-actions">
  
    <button class="glossy-button" mat-button (click)="onDeleteClick()">Yes</button>
    <button class="glossy-button" mat-button (click)="onCancelClick()">No</button>
</div>